module.exports = __webpack_public_path__ + "3a18c975d1a889d0fa285b043f79b612.gif";


//////////////////
// WEBPACK FOOTER
// ./assets/images/paywalls/differentiation.gif
// module id = 3338
// module chunks = 0